import {Logger} from "@variocube/driver-common";

export const logger = new Logger("variocube.carrier");